<div class="admin-user-order-history container">
  <div class="header" fxLayout="row" fxLayoutAlign="space-between center">
    <h2 class="title">فایل‌های به اشتراک گذاری شده</h2>
    <div class="actions">
      <mat-form-field appearance="fill" style="display: none">
        <mat-select #type placeholder="وضعیت">
          <mat-option value="">بدون فیلتر</mat-option>
          <mat-option value="payment">در انتظار پرداخت</mat-option>
          <mat-option value="calculation">تخمین قیمت</mat-option>
          <mat-option value="progress">در حال انجام</mat-option>
          <mat-option value="done">انجام شده</mat-option>
        </mat-select>
      </mat-form-field>
      <button (click)="exportExcel()" mat-flat-button id="exportToExcelButton">
        <span>خروجی اکسل</span>
        <jam-icon
          name="database"
          vertical-align="middle"
          color="primary"
        ></jam-icon>
      </button>
      <button
        mat-icon-button
        (click)="refreshController$.next('')"
        color="primary"
      >
        <jam-icon name="refresh"></jam-icon>
      </button>
      <button mat-icon-button>
        <jam-icon name="more-vertical-f"></jam-icon>
      </button>
    </div>
  </div>

  <h1
    *ngIf="this.dataSource.data && this.dataSource.data.length <= 0"
    style="text-align: center"
  >
    موردی پیدا نشد
  </h1>

  <mat-form-field appearance="outline">
    <input
      (keyup)="searchController$.next({ searchValue: searchInput.value })"
      #searchInput
      type="text"
      placeholder="جستجوی شماره"
      matInput
    />
    <jam-icon matSuffix name="search"></jam-icon>
  </mat-form-field>

  <div class="shared-doc-table-container mat-elevation-z2">
    <div class="example-container mat-elevation-z8">
      <div
        class="example-loading-shade"
        *ngIf="isLoadingResult || isRateLimitReached"
      >
        <mat-spinner *ngIf="isLoadingResult"></mat-spinner>
      </div>

      <table mat-table [dataSource]="dataSource" matSort>
        <!-- Position Column -->
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef>شماره</th>
          <td mat-cell *matCellDef="let element">
            {{ element.id | digitsEnToFa }}
          </td>
          <td mat-footer-cell *matFooterCellDef>مجموع</td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>وضعیت</th>
          <td mat-cell *matCellDef="let element">
            <jam-icon
              *ngIf="element.status === PaymentStatus.Done"
              matTooltipShowDelay="500"
              matTooltip="انجام شده"
              name="check"
            ></jam-icon>
            <jam-icon
              *ngIf="element.status === PaymentStatus.Implementation"
              matTooltipShowDelay="500"
              matTooltip="در حال انجام"
              name="clock"
            ></jam-icon>
            <jam-icon
              *ngIf="element.status === PaymentStatus.Payment"
              matTooltipShowDelay="500"
              matTooltip="در انتظار پرداخت"
              name="credit-card-f"
            ></jam-icon>
            <jam-icon
              *ngIf="element.status === PaymentStatus.NotDone"
              matTooltipShowDelay="500"
              matTooltip="انجام نشده"
              name="hourglass"
            ></jam-icon>

            <jam-icon
              *ngIf="element.status === PaymentStatus.Sent"
              matTooltipShowDelay="500"
              matTooltip="ارسال شده"
              name="car"
            ></jam-icon>
            <jam-icon
              *ngIf="element.status === PaymentStatus.Canceled"
              matTooltipShowDelay="500"
              matTooltip="ناموفق"
              name="close"
            ></jam-icon>
          </td>
          <td mat-footer-cell *matFooterCellDef>مجموع</td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>تاریخ ثبت</th>
          <td mat-cell *matCellDef="let element">
            {{
              getDate(element.createdAt) | jdate : "d mmm yyyy"
            }}
          </td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <!-- Weight Column -->
        <ng-container matColumnDef="amount">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>مبلغ سفارش</th>
          <td mat-cell *matCellDef="let element">
            {{ element.amount | irc : "T" | digitsEnToFa }}
          </td>
          <td mat-footer-cell *matFooterCellDef>
            {{ getTotalCost() | irc : "T" | digitsEnToFa }}
          </td>
        </ng-container>

        <!-- Symbol Column -->
        <ng-container matColumnDef="user">
          <th mat-header-cell *matHeaderCellDef>کاربر</th>
          <td mat-cell *matCellDef="let element">
            {{ element?.user?.fullName }}
          </td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>عملیات</th>
          <td mat-cell *matCellDef="let element">
            <button (click)="preview(element)" mat-icon-button color="primary">
              <jam-icon name="eye-f"></jam-icon>
            </button>
          </td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"
        ></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

        <tr
          class="total-cell"
          mat-footer-row
          *matFooterRowDef="displayedColumns; sticky: true"
        ></tr>
      </table>

      <mat-paginator
        [pageSizeOptions]="[5, 10, resultsLength]"
        [length]="resultsLength"
        [class.z-hidden]="isLoadingResult"
        class="paginator"
        showFirstLastButtons
        aria-label="Select page of periodic elements"
      >
      </mat-paginator>
    </div>
  </div>
</div>
